type HostEnv = 'production' | 'stage' | 'development' | 'sandbox';

const isDeveloper = computed(() => {
  const { relevantCookies } = useWwwStorage();
  const devCookie = relevantCookies.value.find(
    (cookie) => cookie.name === 'x-www-is-internal-developer'
  );
  return devCookie?.value;
});

const getHostEnv = (): HostEnv => {
  const url = useRequestURL().host;

  if (url.includes('localhost')) {
    return 'development';
  }

  if (url.includes('stage')) {
    return 'stage';
  }

  if (url.includes('sandbox')) {
    return 'sandbox';
  }

  return 'production';
};

const useEnvContext = () => {
  const hostEnv = getHostEnv();

  return readonly({
    isDev: computed(() => hostEnv === 'development'),
    isStage: computed(() => hostEnv === 'stage'),
    isProd: computed(() => hostEnv === 'production'),
    isSandbox: computed(() => hostEnv === 'sandbox'),
    isDeveloper,
  });
};

export default useEnvContext;
